import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { ENUM__field_connectable_type } from '../_base/_methods/ENUM__field_connectable_type';
import { FIELD__base_visible_connectable } from '../_base/FIELD__base_connectable';
import { FIELD__tensor_image } from './FIELD__tensor_image';
import { FIELD__tensor_latents } from './FIELD__tensor_latents';

export class FIELD__tensor_latents_masked extends FIELD__base_visible_connectable {
  /*
   * STATIC FIELDS
   */
  static readonly _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_TENSOR_LATENTS_MASKED;

  /*
   * FIELDS
   */

  @FIELD__tensor_latents.init_as_field({}, { ui__is_readonly: true })
  latents!: FIELD__tensor_latents;

  @FIELD__tensor_latents.init_as_field({}, { ui__is_readonly: true })
  latents_under_mask!: FIELD__tensor_latents;

  @FIELD__tensor_image.init_as_field({}, { ui__is_readonly: true })
  tensor_image_mask!: FIELD__tensor_image;

  /*
   * PROPERTIES
   */

  field_connectable__value(graph: DTO_GRAPH__instance) {
    return this.meta.field_hash__value_full;
  }

  field_connectable__type() {
    return ENUM__field_connectable_type.TENSOR_LATENTS_MASKED;
  }

  /*
   * EVENTS
   */
}
